var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionFile72(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 88,
    viewBox: "0 0 72 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 79.833V8.167A8.167 8.167 0 018.167 0H48.004l9.498 11.038L72 24v55.833A8.167 8.167 0 0163.833 88H8.167A8.167 8.167 0 010 79.833z",
    fill: "#E9ECEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.028 24H72L48 0v19.972A4.028 4.028 0 0052.028 24z",
    fill: "#CED4DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.518 49.108h0l-.004.003c-.924.709-2.174 1.173-3.78 1.366-.765.091-1.413.716-1.413 1.531v3.817c0 1.07.881 1.922 1.95 1.922 1.07 0 1.952-.852 1.952-1.922v-2.31a11.77 11.77 0 002.328-.767 8.677 8.677 0 002.437-1.62 7.913 7.913 0 001.744-2.44c.477-.993.709-2.137.709-3.42 0-2.331-.743-4.226-2.26-5.63-1.513-1.402-3.553-2.079-6.066-2.079-1.268 0-2.405.172-3.403.525a8.397 8.397 0 00-2.606 1.462 8.45 8.45 0 00-1.82 2.108h0l-.003.004c-.217.363-.41.736-.58 1.117-.435.979.155 2.006 1.079 2.348 1.116.414 2.25-.258 2.733-1.2a5.633 5.633 0 011.136-1.525c.817-.754 1.917-1.15 3.346-1.15 1.326 0 2.333.371 3.07 1.071h0l.006.005c.732.673 1.112 1.586 1.112 2.79v.54c0 1.484-.555 2.62-1.667 3.454zm-5.296 16.614l.005.006.005.005c.48.502 1.191.708 2.032.708.835 0 1.541-.203 2-.713.453-.477.664-1.091.664-1.8v-.465c0-.71-.21-1.324-.663-1.8-.46-.51-1.166-.713-2-.713-.842 0-1.552.205-2.033.707l-.005.006-.005.006c-.427.478-.622 1.09-.622 1.794v.465c0 .703.195 1.316.622 1.794z",
    fill: "#868E96",
    stroke: "#868E96",
    strokeWidth: 0.882
  })));
}

export default SvgQuestionFile72;